export default __webpack_public_path__ + "static/media/proto-1.fbe501f3.png";